import { HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';
import { inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
    const router = inject(Router);
    const activatedRoute = inject(ActivatedRoute);
    const accessToken = localStorage.getItem('accessToken') || '';
    const callCenter = localStorage.getItem('callCenter') === 'true';
    const customToken = localStorage.getItem('customToken') || '';
    const xConsumerUsername = activatedRoute.snapshot.firstChild?.paramMap.get('tenant') || '';

    if (!accessToken && !callCenter) {
        request = request.clone({ headers: request.headers.set('X-Consumer-Username', xConsumerUsername) });
        if (!request.headers.get('x-no-authorization')) {
            request = request.clone({ headers: request.headers.set('Authorization', `${customToken}`) });
        }
    }
    if (request.url.includes('/transactions/auth') || request.url.includes('/createLut')) {
        request = request.clone({ headers: request.headers.set('X-Consumer-Username','tenant72_api') });
    }
    if (accessToken && !request.headers.get('x-no-authorizatison')) {
        if(!request.url.includes('/createLut') && !request.url.includes('/transactions/auth')) {
            request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${accessToken}`) });
        }
    }

    if (request.headers.has('x-no-authorization')) {
        request = request.clone({ headers: request.headers.delete('x-no-authorization') });
    }

    return next(request).pipe(
        tap({
            error: ({ status, ...err }) => {
                const tenantKey = localStorage.getItem('tenantKey') || '';
                if (status === 401) {
                    router.navigateByUrl(`auth/${tenantKey}/login`);
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('selectedUser');
                    localStorage.removeItem('customToken');
                    localStorage.removeItem('tenantKey');
                    localStorage.removeItem('callCenter');
                    localStorage.removeItem('isSubAgent');
                    localStorage.removeItem('parentUserId');
                    localStorage.removeItem('masterAccount');
                    localStorage.removeItem('masterAccountId');
                } else if (status === 403 && err.error.detail === 'Current session is expired, please login again.') {
                    router.navigateByUrl(`auth/${tenantKey}/login`);
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('selectedUser');
                    localStorage.removeItem('customToken');
                    localStorage.removeItem('tenantKey');
                    localStorage.removeItem('callCenter');
                    localStorage.removeItem('permissions');
                    localStorage.removeItem('userInfo');
                    localStorage.removeItem('isSubAgent');
                    localStorage.removeItem('parentUserId');
                    localStorage.removeItem('masterAccount');
                    localStorage.removeItem('masterAccountId');
                    localStorage.clear();
                }
            },
        }),
    );
};
